import './style.scss'

import { smartPopupInit } from '../../../js/components/SmartPopup'
import { showCallUsPopup } from '../../../js/components/CallUsPopup/scripts'

export default !function () {
  let isCallUsPopupScheduled = false

  try {
    isCallUsPopupScheduled = showCallUsPopup()
  } catch (e) {
    window.Sentry.captureException(new Error(`[call-us-popup]: ошибка инициализации call-us-popup ${e.message}`))
  }

  if (!isCallUsPopupScheduled) {
    try {
      smartPopupInit()
    } catch (e) {
      window.Sentry.captureException(new Error(`[smart-popup]: ошибка инициализации smart-popup ${e.message}`))
    }
  }
}();
